import React from 'react';

import PageWrap from '@marvelapp/marvel-ui/page-wrap';
import Button from '@marvelapp/marvel-ui/button';

import generalStyles from './style/general.module.css';

export default function Banner() {
  return (
    <a
      data-testid="ballpark-banner"
      className={generalStyles.link}
      href="https://ballparkhq.com/?utm_campaign=Ballpark%20Launch%200422&utm_source=Marvel%20website&utm_medium=top-banner"
      // we don't want to add rel="noopener noreferrer" as it will prevent us tracking marketing links
      // eslint-disable-next-line react/jsx-no-target-blank
      target="_blank"
    >
      <div className={generalStyles.banner}>
        <PageWrap size="l">
          <div className={generalStyles.flex}>
            <div className={generalStyles.text}>
              User testing for Figma prototypes and simple surveys, now
              available with Ballpark
            </div>
            <div className={generalStyles.readMore}>
              <Button
                size="small"
                shape="rounded"
                kind="ghost"
                hover="white"
                isReversed
              >
                Try for free
              </Button>
            </div>
          </div>
        </PageWrap>
      </div>
    </a>
  );
}



// WEBPACK FOOTER //
// ./src/components/modules/Banner/index.js